export const inventoryIdentifier = (item) =>
  [item?.identifier, item?.meterNumber, item?.meterBarCode, item?.meterNo, item?.meterSerialNumber]
    .find((value) => value != null && String(value).trim() !== "");

// The manual form writes meterComponents; retain reads for legacy components.
export const inventoryComponents = (item) =>
  item?.meterComponents ?? item?.metadata?.meterComponents ??
  item?.components ?? item?.metadata?.components;
